import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import baseurl from "./Baseurl";
import secureLocalStorage from "react-secure-storage";
import "./Manubar.css"; // Import the CSS file
import Swal from "sweetalert2";
import { IoArrowBack } from "react-icons/io5";


const Manubar = () => {
  let Navigate = useNavigate();
  let [showprofile, setshowprofile] = useState([]);
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const items = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          items,
          {
            headers: {
              token: token,
            },
          },
        );

        if (res.data.result) {
          setshowprofile(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching user profile", error);
      }
    };

    fetchUserProfile();
  }, [_id, token]);

  let handleLogout = () => {
    Swal.fire({
      title: "Logout?",
      text: "Do you really want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        secureLocalStorage.clear();
        localStorage.clear();

        Swal.fire({
          title: "Logged Out!",
          text: "You have been successfully logged out.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        window.location.href = "/login";
      }
    });
  };

  

  const handleLogin = () => {
    Navigate("/login");
  };

  return (
    <div className="account-menu-container">
      <div className="account-header">
        <h2>Account</h2>
      </div>

      <div className="account-menu">
        {_id ? (
          <>
            <a href="/editProfile" className="menu-item">
              <div className="menu-icon">
                <IoArrowBack />
              </div>
              <span className="menu-text">Edit Profile</span>
              <i className="las la-angle-right menu-arrow"></i>
            </a>

            <a href="/address" className="menu-item">
              <div className="menu-icon">
                <i className="las la-map-marker"></i>
              </div>
              <span className="menu-text">Address</span>
              <i className="las la-angle-right menu-arrow"></i>
            </a>

            <a href="/myOrders" className="menu-item">
              <div className="menu-icon">
                <i className="las la-box"></i>
              </div>
              <span className="menu-text">My Orders</span>
              <i className="las la-angle-right menu-arrow"></i>
            </a>
          </>
        ) : null}

        <a href="/faq" className="menu-item">
          <div className="menu-icon">
            <i className="las la-question-circle"></i>
          </div>
          <span className="menu-text">FAQ</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        <a href="/refundPolicy" className="menu-item">
          <div className="menu-icon">
            <i className="las la-undo-alt"></i>
          </div>
          <span className="menu-text">Return & Refund Policy</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        <a href="/aboutGemstones" className="menu-item">
          <div className="menu-icon">
            <i className="las la-gem"></i>
          </div>
          <span className="menu-text">About Gemstones</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        <a href="/aboutUs" className="menu-item">
          <div className="menu-icon">
            <i className="las la-info-circle"></i>
          </div>
          <span className="menu-text">About Us</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        <a href="/termsAndCondition" className="menu-item">
          <div className="menu-icon">
            <i className="las la-file-alt"></i>
          </div>
          <span className="menu-text">Leasing Terms & Conditions</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        <a href="/privacyPolicy" className="menu-item">
          <div className="menu-icon">
            <i className="las la-shield-alt"></i>
          </div>
          <span className="menu-text">Privacy Policy</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        <a href="/contact-us" className="menu-item">
          <div className="menu-icon">
            <i className="las la-headset"></i>
          </div>
          <span className="menu-text">Contact Us</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        <a href="/wishlist" className="menu-item">
          <div className="menu-icon">
            <i className="las la-heart"></i>
          </div>
          <span className="menu-text">Wishlist</span>
          <i className="las la-angle-right menu-arrow"></i>
        </a>

        {_id ? (
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        ) : (
          <button onClick={handleLogin} className="logout-button">
            Login
          </button>
        )}
      </div>
    </div>
  );
};

export default Manubar;
